// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__YoJCc","inviewFade":"styles_inviewFade__2N1h_"};